import { BarChart, Bar, XAxis, YAxis, Tooltip, LabelList, ResponsiveContainer, Cell } from 'recharts';

interface ChartItem {
  count: string[];
  countListMedicalInWorkstation: string;
  totalEmployeesFoundInWorkstation: string;
  workstation: string;
}

const BAR_COLORS = ['#413ea0', '#5b57c2', '#7572d5', '#8e8be0', '#a7a5eb'];

export const RankWorkstationWithMoreMedicalCertificate = ({ data }: { data: ChartItem[] }) => {
  const chartData = data.map(item => {
    const atestados = Number(item.countListMedicalInWorkstation);
    const total = Number(item.totalEmployeesFoundInWorkstation);
    const percentage = total > 0 ? Math.round((atestados / total) * 100) : 0;
    const fullLabel = item.workstation;

    return {
      ...item,
      shortName: fullLabel.length > 22 ? fullLabel.slice(0, 22) + '…' : fullLabel,
      atestados,
      total,
      percentage,
      barLabel: `${atestados} de ${total}`,
    };
  });

  const controllerHeight = Math.max(chartData.length * 56 + 60, 140);

  return (
    <div style={{ width: '100%'}}>
      <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0' }}>
        Taxa de absenteísmo por setor
      </p>
      <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
        Percentual de colaboradores com atestado em relação ao total do setor
      </span>

      <ResponsiveContainer width="100%" height={controllerHeight}>
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 16, right: 50, bottom: 10, left: -40 }}
        >
          <XAxis
            type="number"
            domain={[0, 100]}
            tickFormatter={(value) => `${value}%`}
            ticks={[0, 25, 50, 75, 100]}
            tick={{ fontSize: 12, fill: '#8d95a0' }}
            axisLine={{ stroke: '#e2e5ea' }}
            tickLine={false}
          />

          <YAxis
            type="category"
            dataKey="shortName"
            width={150}
            tick={{ fontSize: 13, fill: '#4a4f5c', fontWeight: 500 }}
            tickLine={false}
            axisLine={false}
          />

          <Tooltip
            cursor={{ fill: 'rgba(65, 62, 160, 0.06)' }}
            content={({ active, payload }) => {
              if (!active || !payload?.length) return null;
              const item = payload[0].payload;
              return (
                <div style={{
                  background: '#fff',
                  border: '1px solid #e2e5ea',
                  borderRadius: 8,
                  padding: '10px 14px',
                  fontSize: 13,
                  color: '#2d3142',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                }}>
                  <p style={{ margin: 0, fontWeight: 600, fontSize: 14 }}>
                    {item.workstation}
                  </p>
                  <p style={{ margin: '6px 0 0', color: '#6b7280' }}>
                    Colaboradores com atestados: <strong style={{ color: '#413ea0' }}>{item.atestados}</strong> de{' '}
                    <strong>{item.total}</strong> colaboradores
                  </p>
                  <p style={{ margin: '4px 0 0', color: '#6b7280' }}>
                    Taxa: <strong style={{ color: '#413ea0' }}>{item.percentage}%</strong>
                  </p>
                </div>
              );
            }}
          />

          <Bar
            dataKey="percentage"
            name="Absenteísmo"
            radius={[0, 6, 6, 0]}
            barSize={26}
          >
            {chartData.map((_, index) => (
              <Cell key={index} fill={BAR_COLORS[index % BAR_COLORS.length]} />
            ))}
            <LabelList
              dataKey="barLabel"
              position="right"
              style={{ fontSize: 12, fill: '#4a4f5c', fontWeight: 600 }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};